/**
 * File-kind classification shared by the Depot browser and the Lore pilot
 * browser. Extracted from Depot.tsx so pages/Lore.tsx doesn't have to
 * import the whole depot module for three helpers.
 */

export const IMAGE_EXTS = new Set([
  'png', 'jpg', 'jpeg', 'webp', 'gif', 'tif', 'tiff', 'svg', 'avif',
  'heic', 'heif', 'tga', 'targa', 'bmp', 'psd', 'psb', 'ico', 'icns',
  'xpm', 'pcx', 'ppm', 'pgm', 'pbm', 'dds', 'exr', 'hdr', 'pic',
]);
export const VIDEO_EXTS = new Set(['mp4', 'mov', 'avi', 'webm', 'mkv', 'mpeg', 'm4v', 'ogv', '3gp']);
export const AUDIO_EXTS = new Set(['mp3', 'wav', 'flac', 'ogg', 'oga', 'aiff', 'aif', 'au', 'm4a', 'opus']);
export const THREED_EXTS = new Set(['fbx', 'obj', 'stl', 'dae', 'ply', '3ds', 'blend', 'x3d', 'glb', 'gltf']);
export const DAM_PREVIEWABLE_EXTS = new Set([
  ...IMAGE_EXTS, ...VIDEO_EXTS, ...AUDIO_EXTS, ...THREED_EXTS,
  'pdf', 'uasset',
]);

export function extOf(p: string): string {
  const idx = p.lastIndexOf('.');
  return idx >= 0 ? p.slice(idx + 1).toLowerCase() : '';
}

export function basename(path: string): string {
  return path.split('/').filter(Boolean).pop() ?? path;
}
